/**
 * User: Rob Richard
 * Date: 12/19/13
 * Time: 12:11 PM
 */

"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var Role = module.exports = SoaModel.extend();

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Permissions = require('bunsen/collections/identity/PermissionList');
var Permission = require('bunsen/models/identity/Permission');
var Backbone = require('dibs-backbone');

_.extend(Role.prototype, {
    /**
     *
     * @returns {string}
     */
    url: function () {
        return endpoints.role(this.get(this.idAttribute));
    },
    relations: [
        {
            type: Backbone.Many,
            key: 'permissions',
            collectionType: Permissions,
            omitFromSave: true
        },
        {
            type: Backbone.One,
            key: 'assignPermission',
            relatedModel: Permission.extend({
                // The default permission for assigning roles
                defaults: {
                    name: 'ASSIGN_ROLES'
                }
            })
        }
    ],
    initialize: function () {
        _.bindAll(this, 'removeRoleFromUser', 'saveRoleForUser');
    },

    _setUserRoleUrl: function () {
        var oldUrl = this.url;
        var id = this.collection.parents[0].id;

        this.url = endpoints.user(id) + '/role/' + this.get('name');

        return oldUrl;
    },
    removeRoleFromUser: function (options) {
        var oldUrl = this._setUserRoleUrl();
        var xhr;

        // collection parent MUST be the user!
        xhr = this.destroy(options);
        this.url = oldUrl;

        return xhr;
    },
    saveRoleForUser: function (passedOptions) {
        var oldUrl = this._setUserRoleUrl();
        var options = passedOptions || {};
        var xhr;

        //pick these keys of attributes and send them to service on save (some instance of Role may not have one or more of these keys)
        var payloadAttrs = ['id', 'userStatus'];
        options.attrs = _.pick(this.toJSON(), payloadAttrs);

        // collection parent MUST be the user!
        xhr = this.save(null, options);
        this.url = oldUrl;

        return xhr;
    },
    removeRoleFromPermission: function (permissionId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(this.get('id'), permissionId);

        // Sync here instead of destroy because event's shouldn't be triggered
        return this.sync('delete', this, _.defaults(options, {
            url: url
        }));
    },
    addRoleToPermission: function (permissionId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(this.get('id'), permissionId);

        return this.sync('create', this, _.defaults(options, {
            url: url
        }));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/Role.js
// module id = 1592
// module chunks = 62